import { useState } from 'react';
import { css } from 'styled-components';
import styled from 'styled-components';
import { Label, ColorOption, ColorPickerContainer } from './StyledComponents';
import ColorPicker from '../ColorPicker';

const AudienceColors = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #dbdde0;
  border-radius: 8px;
  padding: 8px 16px 8px 16px;

  ${props =>
    props.$hasError &&
    css`
      border-color: var(--red-9);
    `}
`;

const ColorPickerWrapper = styled.div`
  width: 24px;
  height: 24px;
`;

const ErrorLabel = styled(Label)`
  color: var(--red-9);
`;

const ErrorMessage = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: var(--red-9);
`;

const popoverStyle = css`
  top: 370px !important;
  left: 360px !important;
  z-index: 999;
`;

const colorOptions = [
  '#ffb748',
  '#ff687b',
  '#b6a9f1',
  '#4fd4c0',
  '#42b2ee',
  '#40beff',
  '#8da0ab',
];

const renderColorOptions = (setColor, selected) =>
  colorOptions.map((background, index) => (
    <ColorOption
      key={index}
      className="color-option"
      background={background}
      isSelected={selected === background}
      onClick={() => setColor(background)}
    />
  ));

export const ColorsPicker = ({ color, setColor, error }) => {
  const LabelComponent = error ? ErrorLabel : Label;
  const [portalNode, setPortalNode] = useState(null);

  return (
    <ColorPickerContainer>
      <LabelComponent>Select a color</LabelComponent>
      <AudienceColors className="audience-colors" $hasError={!!error}>
        {renderColorOptions(setColor, color)}
        <ColorPickerWrapper ref={setPortalNode}>
          <ColorPicker
            colorChangeHandler={color => {
              setColor(color);
            }}
            popoverStyle={popoverStyle}
            portalNode={portalNode}
          />
        </ColorPickerWrapper>
      </AudienceColors>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </ColorPickerContainer>
  );
};

export default ColorsPicker;
